// Resellers — the synced roster from radius_resellers (Company → Reseller
// List, refreshed by the radiussync ticker). Admin/support only on the
// server (a reseller-role token gets 403). Read-only for now; backs the
// reseller picker on the Users page.

import type { ApiClient } from "./client.js";
import type { ResellersListResponse } from "./types.js";

export function makeResellersApi(client: ApiClient) {
  return {
    /** The reseller roster, ordered by client count then name. */
    list() {
      return client.get<ResellersListResponse>("/v1/api/resellers/list");
    },
  };
}

export type ResellersApi = ReturnType<typeof makeResellersApi>;
